






import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';
import { Process } from '@attensi/api-js';

@Component
export default class ProcessView extends Vue {
  @Getter('processModule/activeProcess') activeProcess!: Process;
}
